import { Checkbox, List, Popover, Typography } from 'antd'
import * as React from 'react'

import { MoreHorizontalIcon } from '../icons'
import { AlignLeftRight } from '../layout'
import { EditableLabel } from '../editable-label'
import { TodoItem } from './dtos'

import * as styles from './TodoItem.module.less'

const { Text } = Typography

export interface TodoItemProps extends TodoItem {
	deleteTodoItem: (id: string) => void
	renameTodoItem: (id: string, title: string) => void
	toggleTodo: (id: string) => void
}

export const TodoListItem: React.FC<TodoItemProps> = (props) => {
	const { deleteTodoItem, id, isCompleted, renameTodoItem, title, toggleTodo } = props

	const handleRenameTodo = (title: string) => {
		renameTodoItem(id, title)
	}

	const editableTitle = (
		<EditableLabel
			canEdit={true}
			editOnClick={true}
			htmlTag={isCompleted ? 'del' : 'span'}
			initialValue={title}
			onSave={handleRenameTodo}
			setCursorOnFocus={'selectAll'}
		/>
	)
	const item = isCompleted ? (
		<Text delete={isCompleted} type='secondary'>
			{editableTitle}
		</Text>
	) : (
		<Text>{editableTitle}</Text>
	)

	const handleToggle = () => {
		toggleTodo(id)
	}

	const handleDeleteListItem = () => {
		deleteTodoItem(id)
	}

	const popoverContent = (
		<List>
			<List.Item
				className={styles.todoItem}
				style={{ padding: '.5rem', cursor: 'pointer' }}
				onClick={handleDeleteListItem}
			>
				Delete item
			</List.Item>
		</List>
	)

	return (
		<List.Item className={styles.todoItem} key={id}>
			<AlignLeftRight
				style={{ width: '100%' }}
				left={
					<React.Fragment>
						<Checkbox defaultChecked={isCompleted} onChange={handleToggle} /> {item}
					</React.Fragment>
				}
				right={
					<Popover placement='bottomRight' title={'Item Actions'} content={popoverContent} trigger='click'>
						<div className={styles.actions}>
							<MoreHorizontalIcon />
						</div>
					</Popover>
				}
			/>
		</List.Item>
	)
}
